import { createStyles, makeStyles } from "@material-ui/core";
import classnames from "classnames";
import * as React from "react";

import { FeedbackTypeEnum } from ".";
import { RelodeTheme, ThumbsDownIcon, ThumbsUpIcon } from "../..";
import { PageActionButton } from "../../../../core/src/components";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            upButton: {
                opacity: 0.2,
            },
            upSpan: {
                marginRight: theme.spacing(1),
            },
            downButton: {
                marginRight: theme.spacing(0.5),
                opacity: 0.2,
            },
            iconButton: {
                borderRadius: 24,
            },
            selectedButton: {
                opacity: "unset",
            },
        }),
    { name: "FeedbackButtons" }
);

interface FeedbackSearchIconsProps {
    onClick: (
        voteType: FeedbackTypeEnum,
        jobId: number,
        jobName: string,
        leadId: number,
        fullName: string,
        comment: string,
        canGiveFeedback: boolean,
        hasGivenFeedback: boolean,
        isJobUser: boolean
    ) => void;
    jobId: number;
    jobName: string;
    leadId: number;
    fullName: string;
    comment: string;
    selectedFeedbackType?: FeedbackTypeEnum;
    showFeedbackCounts?: boolean;
    upCount?: number;
    downCount?: number;
    canGiveFeedback: boolean;
    hasGivenFeedback: boolean;
    isJobUser: boolean;
    feedbackMessage?: string;
}

export const FeedbackSearchIcons = (props: FeedbackSearchIconsProps) => {
    const classes = useStyles({});
    const {
        onClick,
        jobId,
        jobName,
        leadId,
        fullName,
        comment,
        selectedFeedbackType,
        showFeedbackCounts,
        downCount,
        upCount,
        canGiveFeedback,
        hasGivenFeedback,
        feedbackMessage,
        isJobUser,
    } = props;

    const upButtonClass = classnames(
        {
            [classes.iconButton]: !showFeedbackCounts,
            [classes.selectedButton]:
                selectedFeedbackType == FeedbackTypeEnum.Positive,
        },
        classes.upButton
    );

    const downButtonClass = classnames(
        {
            [classes.iconButton]: !showFeedbackCounts,
            [classes.selectedButton]:
                selectedFeedbackType == FeedbackTypeEnum.Negative,
        },
        classes.downButton
    );
    return (
        <>
            {showFeedbackCounts ? (
                <>
                    <span className={classes.upSpan}>
                        <PageActionButton
                            id="positiveFeedbackButton"
                            color="primary"
                            size="medium"
                            className={upButtonClass}
                            title={
                                canGiveFeedback
                                    ? "give feedback"
                                    : feedbackMessage
                            }
                            onClick={() =>
                                onClick(
                                    FeedbackTypeEnum.Positive,
                                    jobId,
                                    jobName,
                                    leadId,
                                    fullName,
                                    comment,
                                    canGiveFeedback,
                                    hasGivenFeedback,
                                    isJobUser
                                )
                            }
                        >
                            <ThumbsUpIcon />
                        </PageActionButton>
                        {upCount ? upCount : 0}
                    </span>
                    <span>
                        <PageActionButton
                            id="negativeFeedbackButton"
                            color="primary"
                            size="medium"
                            className={downButtonClass}
                            onClick={() =>
                                onClick(
                                    FeedbackTypeEnum.Negative,
                                    jobId,
                                    jobName,
                                    leadId,
                                    fullName,
                                    comment,
                                    canGiveFeedback,
                                    hasGivenFeedback,
                                    isJobUser
                                )
                            }
                        >
                            <ThumbsDownIcon />
                        </PageActionButton>
                        {downCount ? downCount : 0}
                    </span>
                </>
            ) : (
                <>
                    <span className={classes.upSpan}>
                        <PageActionButton
                            color="primary"
                            size="medium"
                            className={upButtonClass}
                            onClick={() =>
                                onClick(
                                    FeedbackTypeEnum.Positive,
                                    jobId,
                                    jobName,
                                    leadId,
                                    fullName,
                                    comment,
                                    canGiveFeedback,
                                    hasGivenFeedback,
                                    isJobUser
                                )
                            }
                        >
                            <ThumbsUpIcon />
                        </PageActionButton>
                        {"  "}
                    </span>
                    <span>
                        <PageActionButton
                            color="primary"
                            size="medium"
                            className={downButtonClass}
                            onClick={() =>
                                onClick(
                                    FeedbackTypeEnum.Negative,
                                    jobId,
                                    jobName,
                                    leadId,
                                    fullName,
                                    comment,
                                    canGiveFeedback,
                                    hasGivenFeedback,
                                    isJobUser
                                )
                            }
                        >
                            <ThumbsDownIcon />
                        </PageActionButton>
                    </span>
                </>
            )}
        </>
    );
};
